import {PaginationSortDirection} from '../enums/pagination/pagination-sort-direction.enum';
import {AvailablePaginationSize} from '../types/available-pagination-size.type';

export interface PaginationEvent {
  first: number;
  rows: AvailablePaginationSize;
  page: number;
  pageCount: number;
  sort?: PaginationSorting;
}

export interface PaginationSorting {
  field: string;
  direction: PaginationSortDirection;
}

export class PageableRequest {
  constructor(
    public page: number = 0,
    public size: AvailablePaginationSize = 50,
    public sort?: PaginationSorting
  ) {
  }

  public static fromPaginationComponent(event: PaginationEvent): PageableRequest {
    return new PageableRequest(
      event.page,
      event.rows,
      event.sort
    );
  }

  public toParams(): Record<string, string | string[]> {
    const params: Record<string, string | string[]> = {
      page: this.page.toString(),
      size: this.size.toString()
    };

    if (this.sort) {
      params['sort'] = `${this.sort.field},${this.sort.direction}`;
    }

    return params;
  }

  public resolveSortDirection(sortOrder: number): PaginationSortDirection {
    return sortOrder === 1 ? PaginationSortDirection.ASC : PaginationSortDirection.DESC;
  }
}
